/* Iceman 2026 系列頁：顏色／款式／寬度／只看有貨／排序、看更多、最多人這樣疊、組合橫幅、快速選購＋加入購物車 */
(function () {
  var LEN = {
    '16': { t: '16"（40cm）・貼頸', d: '貼著脖子的短鍊。細鍊單戴最俐落，疊戴放最內層。' },
    '18': { t: '18"（45cm）・鎖骨下方一點', d: '落在鎖骨下方一點，俐落乾淨。單戴最好看。' },
    '20': { t: '20"（50cm）・上胸口', d: '落在上胸口，圓領 T 外剛好露出。最多人選的長度。' },
    '22': { t: '22"（55cm）・接近胸口中間', d: '疊戴當外層，跟 18" 或 20" 拉出層次。' },
    '24': { t: '24"（60cm）・胸口中間', d: '垂到胸口，街頭感最強。配寬鬆上衣或敞開的襯衫。' }
  };
  var CM = { '16': 40, '18': 45, '20': 50, '22': 55, '24': 60 };
  var IN = { '6': 15.2, '6.5': 16.5, '7': 17.8, '7.5': 19, '8': 20.3, '8.5': 21.6 };
  var FIT = { '6': '14–15cm', '6.5': '15.5–16cm', '7': '16.5–17cm', '7.5': '17.5–18.5cm', '8': '19–19.5cm', '8.5': '20.5–21cm' };
  var STY = {
    n: [['all', '全部款式'], ['plain', 'PLAIN 古巴'], ['rope', 'THE ROPE 麻花'], ['tennis', 'ICE SPARKLER Tennis'], ['iced', 'ICEMAN・ICE PRONG']],
    e: [['all', '全部款式'], ['hoop', 'HOOP 圈形'], ['moissanite', '莫桑石'], ['other', '其他款式']],
    mix: [['all', '全部'], ['n', '項鍊'], ['b', '手鍊'], ['e', '耳環'], ['s', '組合']]
  };
  STY.b = STY.n; STY.s = STY.n;
  var COLORS = [['all', '全部', ''], ['w', 'White Gold', 'linear-gradient(135deg,#ffffff,#c4c7cc)'], ['g', '18K Gold', 'linear-gradient(135deg,#f6dc95,#b8862b)']];
  var WIDTHS = [['all', '全部', ''], ['thin', '細', '3–4mm'], ['mid', '中', '5–6mm'], ['thick', '粗', '8mm 以上']];
  var SORTS = [['rec', '推薦'], ['asc', '價格低到高'], ['desc', '價格高到低']];

  function money(c) { return 'NT$' + Math.round(c / 100).toLocaleString('en-US'); }
  function keyOf(v) { return v ? String(v).split('（')[0].replace(/["“”]/g, '').trim() : ''; }
  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function wcat(w) { return w <= 4 ? 'thin' : w <= 6 ? 'mid' : 'thick'; }
  var desk = window.matchMedia('(min-width: 990px)');

  // ---------- 快速選購（系列頁、首頁共用）
  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }
  function img(url, w) {
    if (!url) return '';
    url = typeof url === 'string' ? url : url.src || url.url || '';
    url = url.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + 'width=' + w;
  }

  function Quick(root) {
    var wrap = $(root, '[data-qsheet]'); if (!wrap) return null;
    var toastEl = $(root, '[data-toast2]'), toastTimer, lastFocus;
    var Q = { p: null, info: null, kind: '', sel: {}, guide: false, tryImg: '' };

    function close() { wrap.hidden = true; document.documentElement.classList.remove('icm-lock'); if (lastFocus) lastFocus.focus(); }
    $$(wrap, '[data-close-q]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !wrap.hidden) close(); });

    function toast(text, cart) {
      clearTimeout(toastTimer);
      $(toastEl, '[data-toast2-text]').textContent = text;
      $(toastEl, '[data-toast2-cart]').hidden = !cart;
      toastEl.hidden = false;
      toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2600);
    }

    function combos() {
      // key → [price, available, id, compare]
      var m = {};
      Q.p.variants.forEach(function (v) {
        var k = Q.kind === 'e' ? '' : Q.kind === 's' ? keyOf(v.option1) + '/' + keyOf(v.option2) : keyOf(v.option1);
        m[k] = [v.price, v.available, v.id, v.compare_at_price || 0];
      });
      return m;
    }
    function ok(m, k) { return !!(m[k] && m[k][1]); }
    function preselect(m) {
      var keys = Object.keys(m), av = keys.filter(function (k) { return m[k][1]; });
      if (Q.kind === 'e') return {};
      // 手鍊尺寸跟商品頁一樣不幫客人先選（量手腕再選；卡在中間選大的）；項鍊長度先選最多人選的 20"
      if (Q.kind === 's') {
        var ns = av.map(function (k) { return k.split('/')[0]; });
        return { n: ns.indexOf('20') >= 0 ? '20' : ns[0] || '', b: '' };
      }
      if (Q.kind === 'b') return { x: '' };
      return { x: av.indexOf('20') >= 0 ? '20' : av[0] || '' };
    }
    function dimsOf(m) {
      var ns = [], bs = [];
      Q.p.variants.forEach(function (v) {
        var a = keyOf(v.option1), b = keyOf(v.option2);
        if (a && ns.indexOf(a) < 0) ns.push(a);
        if (Q.kind === 's' && b && bs.indexOf(b) < 0) bs.push(b);
      });
      if (Q.kind === 'e') return [];
      if (Q.kind === 's') return [{ key: 'n', label: '項鍊長度', opts: ns }, { key: 'b', label: '手鍊尺寸', opts: bs }];
      return [{ key: 'x', label: Q.kind === 'b' ? '尺寸' : '長度', opts: ns }];
    }

    function render() {
      var m = combos(), sel = Q.sel, dims = dimsOf(m), sold = !Q.p.available;
      var key = Q.kind === 'e' ? '' : Q.kind === 's' ? sel.n + '/' + sel.b : sel.x, good = ok(m, key);
      var html = '';
      dims.forEach(function (dm) {
        html += '<div class="icm-q__label">' + dm.label + '</div><div class="icm-q__opts" style="--n:' + Math.max(dm.opts.length, 2) + '">';
        dm.opts.forEach(function (k) {
          var avail, sub;
          if (Q.kind === 's') {
            avail = dm.key === 'n' ? dims[1].opts.some(function (b) { return ok(m, k + '/' + b); }) : ok(m, sel.n + '/' + k);
            sub = !avail ? '缺貨' : dm.key === 'n' ? (CM[k] ? CM[k] + 'cm' : '') : (IN[k] ? IN[k] + 'cm' : '');
          } else { avail = ok(m, k); sub = avail ? money(m[k][0]) : '已售完'; }
          var on = sel[dm.key] === k, hot = Q.kind === 'n' && k === '20' && avail;
          html += '<button type="button" class="icm-q__opt' + (avail ? '' : ' is-sold') + '" data-dim="' + dm.key + '" data-k="' + esc(k) + '" aria-pressed="' + on + '"' + (avail ? '' : ' disabled') +
            ' aria-label="' + esc(k) + ' 吋' + (avail ? '' : '，' + sub) + '"><span class="icm-q__optk">' + esc(k) + '"</span><span class="icm-q__opts2">' + sub + '</span>' + (hot ? '<span class="icm-q__flag">最多人選</span>' : '') + '</button>';
        });
        html += '</div>';
      });
      $(wrap, '[data-q-dims]').innerHTML = html;
      $$(wrap, '.icm-q__opt').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.dataset.dim, k = b.dataset.k;
          if (Q.kind === 's' && d === 'n') {
            Q.sel.n = k; if (Q.sel.b && !ok(m, k + '/' + Q.sel.b)) Q.sel.b = '';
          } else Q.sel[d] = k;
          render();
        });
      });
      $(wrap, '[data-q-pairnote]').hidden = Q.kind !== 'e';
      // 看戴起來落在哪／尺寸怎麼選
      var g = $(wrap, '[data-q-guide]'), hasGuide = Q.kind === 'n' || Q.kind === 's' || Q.kind === 'b';
      g.hidden = !hasGuide; g.setAttribute('aria-expanded', Q.guide ? 'true' : 'false');
      $(wrap, '[data-q-guide-label]').textContent = Q.kind === 'b' ? '尺寸怎麼選' : '看戴起來落在哪';
      var selLen = Q.kind === 'n' ? sel.x : Q.kind === 's' ? sel.n : '';
      var tryBox = $(wrap, '[data-q-try]');
      tryBox.hidden = !(Q.guide && (Q.kind === 'n' || Q.kind === 's') && LEN[selLen]);
      if (!tryBox.hidden) {
        var ti = $(wrap, '[data-q-tryimg]'); if (Q.tryImg && ti.getAttribute('src') !== Q.tryImg) ti.src = Q.tryImg;
        var lens = dims.length ? dims[0].opts : [];
        $$(wrap, '[data-qline]').forEach(function (p) { var k = p.dataset.qline; p.classList.toggle('is-off', lens.indexOf(k) < 0); p.classList.toggle('is-on', k === selLen); });
        $(wrap, '[data-q-trytitle]').textContent = LEN[selLen].t; $(wrap, '[data-q-trydesc]').textContent = LEN[selLen].d;
      }
      var sizeBox = $(wrap, '[data-q-size]');
      sizeBox.hidden = !(Q.guide && Q.kind === 'b');
      if (!sizeBox.hidden) {
        var opts = dims[0].opts;
        $(wrap, '[data-q-sizerows]').innerHTML = opts.map(function (k) {
          return '<div class="icm-q__sizerow' + (k === sel.x ? ' is-on' : '') + '"><span>' + esc(k) + '"（' + (IN[k] || '') + 'cm）</span><span>' + (FIT[k] || '') + '</span></div>';
        }).join('');
        $(wrap, '[data-q-sizenote]').textContent = opts.indexOf('7') >= 0 && opts.indexOf('8') >= 0 ? '量手腕最細處一圈。落在哪個範圍就選哪個，卡在中間選大的：手圍 17cm 以下選 7"，超過 17cm 選 8"。' : '量手腕最細處一圈，對照上表選尺寸。';
      }
      // 加入購物車
      var cta = $(wrap, '[data-q-add]'), note = $(wrap, '[data-q-note]'), price = good ? m[key][0] : 0;
      cta.textContent = sold ? '貨到通知我' : good ? '加入購物車・' + money(price) : '先選' + (Q.kind === 'b' ? '尺寸' : Q.kind === 's' && sel.n && !sel.b ? '手鍊尺寸' : '長度');
      var save = good && m[key][3] > price ? m[key][3] - price : 0;
      note.textContent = sold ? '這款目前全部售完' : !good ? '選好再加入' : Q.kind === 'e' ? '一對（兩耳）・' + Q.info.color
        : Q.kind === 's' ? '項鍊 ' + sel.n + '"・手鍊 ' + sel.b + '"' + (save ? '・比分開買省 ' + money(save) : '') : sel.x + '"・' + Q.info.color;
    }

    $(wrap, '[data-q-guide]').addEventListener('click', function () {
      Q.guide = !Q.guide;
      if (Q.guide && Q.kind === 's' && !Q.tryImg) {
        var nh = Q.p.handle.replace('-set-', '-').replace('-chain-', '-necklace-');
        getProduct(nh).then(function (np) { Q.tryImg = img(np.featured_image, 450); render(); }).catch(function () {});
      }
      render();
    });

    $(wrap, '[data-q-add]').addEventListener('click', function () {
      if (!Q.p) return;
      if (!Q.p.available) { window.open(wrap.dataset.line, '_blank', 'noopener'); return; }
      var m = combos(), sel = Q.sel, key = Q.kind === 'e' ? '' : Q.kind === 's' ? sel.n + '/' + sel.b : sel.x;
      if (!ok(m, key)) return;
      var btn = this; btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: m[key][2], quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { toast(res.j.description || '加入失敗，請再試一次', false); return; }
          close();
          var what = (Q.kind === 'n' || Q.kind === 'b' ? sel.x + '" ' : '') + Q.info.series + ' ' + Q.info.name;
          toast('已加入 ' + what, true);
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.setAttribute('data-header-cart-count', cart.item_count); el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('icm:cart:updated', { detail: cart }));
          });
        }).catch(function () { btn.disabled = false; toast('網路有點慢，請再試一次', false); });
    });

    return {
      open: function (handle, info, opener) {
        lastFocus = opener || null;
        getProduct(handle).then(function (p) {
          Q.p = p; Q.info = info; Q.guide = false;
          Q.kind = info.kind || (p.type === 'Bracelets' ? 'b' : p.type === 'Earrings' ? 'e' : (p.tags || []).indexOf('組合') >= 0 ? 's' : 'n');
          Q.tryImg = Q.kind === 'n' ? img(p.featured_image, 450) : '';
          Q.sel = preselect(combos());
          var im = $(wrap, '[data-q-img]'); im.src = img(info.img || p.featured_image, 160); im.alt = '';
          $(wrap, '[data-q-series]').textContent = info.series; $(wrap, '[data-q-name]').textContent = info.name; $(wrap, '[data-q-color]').textContent = info.color;
          $(wrap, '[data-q-page]').href = p.url || '/products/' + handle;
          render();
          wrap.hidden = false; document.documentElement.classList.add('icm-lock');
          var x = $(wrap, '.icm-x'); if (x) x.focus();
        }).catch(function () { toast('網路有點慢，請再試一次', false); });
      }
    };
  }

  function infoOf(card) {
    var im = card.querySelector('img');
    return { kind: card.dataset.kind, series: card.dataset.series, name: card.dataset.name, color: card.dataset.color, img: im ? im.currentSrc || im.src : '' };
  }

  // ---------- 系列頁
  function Coll(root) {
    var cat = root.dataset.cat, grid = $(root, '[data-icm-grid]');
    var cards = $$(grid, '[data-pc]');
    var stack = $(root, '[data-stack]'), setban = $(root, '[data-setban]');
    var quick = Quick(root);
    var hasWidths = cat === 'n' || cat === 'b' || cat === 's';
    var styles = STY[cat === 'mix' ? 'mix' : cat].filter(function (s) {
      return s[0] === 'all' || cards.some(function (c) { return (cat === 'mix' ? c.dataset.kind : c.dataset.st) === s[0]; });
    });
    var st = { color: 'all', style: 'all', width: 'all', stock: false, sort: 'rec', more: false };
    var q = new URLSearchParams(location.search);
    if (q.get('style') && styles.some(function (s) { return s[0] === q.get('style'); })) st.style = q.get('style');
    if (q.get('width') && hasWidths && WIDTHS.some(function (w) { return w[0] === q.get('width'); })) st.width = q.get('width');
    if (q.get('color') && (q.get('color') === 'w' || q.get('color') === 'g')) st.color = q.get('color');

    function set(o) { for (var k in o) st[k] = o[k]; if (!('more' in o)) st.more = false; render(); }
    function pillsHtml(list, cur, cls, attr) {
      return list.map(function (x) { return '<button type="button" class="' + cls + (x[0] === cur ? ' is-on' : '') + '" ' + attr + '="' + x[0] + '" aria-pressed="' + (x[0] === cur) + '">' + x[1] + (x[2] !== undefined && cls.indexOf('wd') >= 0 ? '<small>' + x[2] + '</small>' : '') + '</button>'; }).join('');
    }

    function drawControls() {
      $$(root, '[data-colors]').forEach(function (box) {
        box.innerHTML = COLORS.map(function (c) {
          var on = st.color === c[0];
          return '<button type="button" class="icm-cbtn' + (on ? ' is-on' : '') + '" data-color="' + c[0] + '" aria-pressed="' + on + '">' + (c[2] ? '<i style="background:' + c[2] + '"></i>' : '') + c[1] + '</button>';
        }).join('');
      });
      $$(root, '[data-styles]').forEach(function (box) {
        var side = box.classList.contains('icm-side__styles');
        box.innerHTML = styles.map(function (s) { var on = st.style === s[0]; return '<button type="button" class="' + (side ? 'icm-side__style' : 'icm-spill') + (on ? ' is-on' : '') + '" data-sty="' + s[0] + '" aria-pressed="' + on + '">' + s[1] + '</button>'; }).join('');
      });
      $$(root, '[data-widths]').forEach(function (box) { box.innerHTML = pillsHtml(WIDTHS, st.width, 'icm-wd', 'data-width'); });
      $$(root, '[data-widths-wrap]').forEach(function (w) { w.hidden = !hasWidths; });
      $$(root, '[data-sorts]').forEach(function (box) { box.innerHTML = pillsHtml(SORTS, st.sort, 'icm-sortb', 'data-sort'); });
      $$(root, '[data-stock]').forEach(function (i) { i.checked = st.stock; });
      var nf = (hasWidths && st.width !== 'all' ? 1 : 0) + (st.stock ? 1 : 0) + (st.sort !== 'rec' ? 1 : 0);
      var fl = $(root, '[data-filter-label]'); if (fl) fl.textContent = nf ? '篩選（' + nf + '）' : '篩選';
      var fb = $(root, '[data-open-filter]'); if (fb) fb.setAttribute('aria-label', '篩選與排序' + (nf ? '，已套用 ' + nf + ' 項' : ''));
    }

    function render() {
      var list = cards.filter(function (c) {
        var d = c.dataset;
        return (st.color === 'all' || d.c === st.color) && (st.style === 'all' || (cat === 'mix' ? d.kind : d.st) === st.style)
          && (!hasWidths || st.width === 'all' || wcat(+d.w) === st.width) && (!st.stock || d.sold === '0');
      });
      list.sort(function (a, b) {
        var s = (+a.dataset.sold) - (+b.dataset.sold); if (s) return s;
        if (st.sort === 'asc') return (+a.dataset.min) - (+b.dataset.min) || (+a.dataset.i) - (+b.dataset.i);
        if (st.sort === 'desc') return (+b.dataset.min) - (+a.dataset.min) || (+a.dataset.i) - (+b.dataset.i);
        return (+a.dataset.i) - (+b.dataset.i);
      });
      var isD = desk.matches, first = +(isD ? root.dataset.firstD : root.dataset.first) || 10;
      var shown = st.more ? list.length : Math.min(first, list.length);
      cards.forEach(function (c) { c.hidden = true; });
      if (stack) stack.hidden = true;
      if (setban) setban.hidden = true;
      var frag = document.createDocumentFragment();
      var setAfter = setban ? +setban.dataset.after : 0;
      if (isD && setAfter) setAfter = Math.ceil(setAfter / 4) * 4;
      list.forEach(function (c, i) {
        frag.appendChild(c);
        if (i < shown) c.hidden = false;
        if (stack && i === 3 && i < shown && st.width === 'all' && (st.style === 'all' || st.style === 'plain' || st.style === 'rope')) {
          var pc = st.color === 'w' ? 'w' : 'g', pair = $(stack, '[data-stack-c="' + pc + '"]');
          if (pair) { $$(stack, '[data-stack-c]').forEach(function (x) { x.hidden = x !== pair; }); stack.hidden = false; frag.appendChild(stack); }
        }
        if (setban && i === setAfter - 1 && i < shown) { setban.hidden = false; frag.appendChild(setban); }
      });
      // 其他不在清單的卡片放後面（隱藏）
      cards.forEach(function (c) { if (list.indexOf(c) < 0) frag.appendChild(c); });
      grid.appendChild(frag);
      if (stack && stack.hidden) grid.appendChild(stack);
      if (setban && setban.hidden) grid.appendChild(setban);

      $(root, '[data-empty]').hidden = list.length > 0;
      var total = cards.length;
      $$(root, '[data-count]').forEach(function (e) { e.textContent = list.length === total ? total + ' 款' : list.length + ' / ' + total + ' 款'; });
      var mw = $(root, '[data-more-wrap]');
      mw.hidden = !(list.length > shown);
      if (!mw.hidden) {
        $(root, '[data-seen]').textContent = '已看 ' + shown + ' / ' + list.length + ' 款';
        $(root, '[data-prog]').style.width = Math.round(shown / Math.max(list.length, 1) * 100) + '%';
      }
      $$(root, '[data-show-count]').forEach(function (b) { b.textContent = '顯示 ' + list.length + ' 款'; });
      drawControls();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
      if (t.dataset.color) set({ color: t.dataset.color });
      else if (t.dataset.sty) set({ style: t.dataset.sty });
      else if (t.dataset.width) set({ width: t.dataset.width });
      else if (t.dataset.sort) set({ sort: t.dataset.sort });
      else if (t.hasAttribute('data-clear')) { set({ color: 'all', style: 'all', width: 'all', stock: false, sort: 'rec' }); var fs = $(root, '[data-fsheet]'); if (fs) { fs.hidden = true; document.documentElement.classList.remove('icm-lock'); } }
      else if (t.hasAttribute('data-more')) { st.more = true; render(); }
      else if (t.hasAttribute('data-open-filter')) { $(root, '[data-fsheet]').hidden = false; document.documentElement.classList.add('icm-lock'); }
      else if (t.hasAttribute('data-close-filter')) { $(root, '[data-fsheet]').hidden = true; document.documentElement.classList.remove('icm-lock'); }
      else if (t.hasAttribute('data-quick') && quick) { e.preventDefault(); var card = t.closest('[data-pc]'); quick.open(card.dataset.handle, infoOf(card), t); }
      else if (t.dataset.quickHandle && quick) {
        var c2 = cards.filter(function (c) { return c.dataset.handle === t.dataset.quickHandle; })[0];
        if (c2) quick.open(c2.dataset.handle, infoOf(c2), t);
      }
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-stock]')) set({ stock: e.target.checked }); });
    document.addEventListener('keydown', function (e) { var fs = $(root, '[data-fsheet]'); if (e.key === 'Escape' && fs && !fs.hidden) { fs.hidden = true; document.documentElement.classList.remove('icm-lock'); } });
    if (desk.addEventListener) desk.addEventListener('change', render); else if (desk.addListener) desk.addListener(render);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-icm-coll]').forEach(function (r) { if (!r.__icm) { r.__icm = 1; Coll(r); } });
  }
  window.IcmQuick = Quick;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
